module.exports = __webpack_public_path__ + "media/assets/images/flags/sl-200330183f9db59349b7fb290efe5b1b.svg";